






































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { Form } from '@ss/mtd-vue';
@Component({
    components: {}
})
export default class AddMemberModal extends Vue {
    @Prop({ default: false })
    visible: boolean;

    userOptions: CommonTypes.mapObject = [];
    modalForm: CommonTypes.mapObject = {
        name: []
    };
    rules: CommonTypes.mapObject = {
        name: [
            {
                validator: (_rule, value, callback) => {
                    if (value.length === 0) {
                        callback(new Error('请输入mis号'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur, change'
            }
        ]
    };
    showModal: boolean = false;
    btnLoading: boolean = false;
    loading: boolean = false;

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    // 增加值班人员
    async addOndutyPeople() {
        const modalForm = this.$refs.modalForm as Form;
        modalForm
            .validate(async valid => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        const params = {
                            rgId: this.rgId,
                            mis: this.modalForm.name
                        };
                        const res = await api.oncallApi.addOncallMember(params);
                        if (res && res.code === 200) {
                            this.btnLoading = false;
                            this.$mtd.message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.$emit('success');
                            this.close();
                        }
                    } catch (e) {
                        this.btnLoading = false;
                        console.log(e);
                    }
                } else {
                    console.error('Fail!');
                }
            })
            .catch(e => e);
    }
    // 远程搜索用户
    async remoteMethod(query?: any) {
        const params = {
            rgId: this.rgId,
            identify: query || '',
            includeOncall: false
        };
        const res = await api.rgApi.getRgUser(params);
        if (res && res.code === 200) {
            this.userOptions = res.data.items;
            this.loading = false;
        }
    }
    close() {
        this.$emit('update:visible', false);
    }
    confirm() {
        this.close();
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
